export const GRID_ITEM_STYLES = 'bg-canvas-tertiary-main w-full md:h-full isolate';

export const SCROLLABLE_GRID_PARENT_STYLES = 'md:relative h-auto max-h-4/5 md:block';

export const SCROLLABLE_GRID_ITEM_STYLES =
  'w-full md:absolute md:overflow-y-auto md:overflow-x-hidden md:h-full md:w-[inherit] md:block';
